import { createSelector } from '@ngrx/store';

import { getAssetLoading } from './delivery-asset.selectors';
import { getDeliveryLoading } from './delivery.selectors';

export const getIsLoading = createSelector(
  getAssetLoading,
  getDeliveryLoading,
  (assetLoading, deliveryLoading) => assetLoading || deliveryLoading,
);
